import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateIngredientOverridesIngredientsDetails($id: ID!, $data: [ID!]) {
    updateIngredientOverridesIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      overridesIngredients {
        id
      }
    }
  }
`

export default UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS_MUTATION
